<template>
  <!-- BUY MODAL -->
  <div class="payment-view">
    <nav class="navbar has-border-bottom is-fixed-top">
      <div class="container">
        <div class="navbar-brand">
          <!-- <button  style="border: 0; padding: 0; background-color: white"> -->
          <BackButton></BackButton>

          <div class="navbar-item pl-half">
            <p class="title has-text-weight-medium is-5">{{ $t('ui.payment') }}</p>
          </div>

          <div class="ml-auto navbar-item has-text-grey-dark">
            <span aria-role="step-button">{{ stepIndicator }} {{ $t('ui.step') }}</span>
          </div>

          <!-- </button> -->
        </div>
      </div>
    </nav>

    <b-loading
      animation
      :is-full-page="false"
      :active.sync="$store.state.ui.isLoading"
      :can-cancel="false"
    >
      <!-- <b-icon pack="mdi" icon="sync-alt" size="is-large" custom-class="mdi-spin"></b-icon> -->
    </b-loading>

    <!-- TODO delete this -->
    <!-- <div class="page-body is-open">
    </div>-->

    <keep-alive>
      <!-- keep alive is for caching, and when you assign a key it caches the with theat  -->
      <router-view class="page-body is-open" :key="$route.fullPath"></router-view>
    </keep-alive>

    <!-- PAYMENT BOTTOM NAVBAR -->
    <nav
      class="bottom-navbar--buy level navbar is-mobile is-fixed-bottom p-half mb-0"
      :class="{ 'hidden-navbar': !showPaymentBottomNavbar }"
    >
      <div class="level-left">
        <div
          class="columns"
          style="padding: 0.25rem 0 0.25rem 0.75rem;"
          @click="$store.dispatch('ui/toggleModal', { name: 'TICKET_MODAL', state: true })"
        >
          <span class="column is-paddingless has-text-weight-semibold is-size-5">
            {{ basketTotal.totalPrice }} ₺
            <span
              class="is-size-7 has-text-weight-normal"
            >{{ basketTotal.totalItems }} {{$t('ui.ticket') }}</span>
          </span>
          <span
            class="column is-paddingless is-size-6-half has-text-weight-semibold has-text-info"
          >{{ $t('ui.seeTicket') }}</span>
        </div>
      </div>
      <div class="level-right">
        <p class="control" v-if="$route.name === 'payment-event-rules'">
          <button
            @click="agreeEventRules"
            class="button is-buy has-text-weight-bold is-primary is-default-size"
          >{{ $t('ui.agree') }}</button>
        </p>
        <p class="control" v-if="$route.name === 'payment-customer-info'">
          <button
            :disabled="!$store.state.user.userDoc.userBasket.customerInfo.isConfirmed"
            @click="confirmCustomerInfo"
            class="button is-buy has-text-weight-bold is-primary is-default-size"
          >{{ $t('ui.continue') }}</button>
        </p>
        <p class="control" v-if="$route.name === 'payment-card-info'">
          <button
            @click="makePayment"
            :disabled="!$store.state.user.userDoc.userBasket.isCardInfoConfirmed"
            class="button is-buy has-text-weight-bold is-default-size is-danger"
          >{{ $t('ui.pay') }}</button>
        </p>
      </div>
    </nav>

    <TicketModal></TicketModal>
  </div>

  <!-- ./BUY MODAL -->
</template>

<script>
import { mapGetters, mapMutations } from "vuex";
import TicketModal from "@/components/payment/TicketModal";
import BackButton from '@/components/ui/BackButton';

export default {
  components: {
    TicketModal,
    BackButton
  },
  beforeMount() {
    console.log('rouet qureatert', this.$route);
    if (!this.userBasket) {
      this.$router.push({ name: "event-view", params: { eventID: this.$route.query.eventID }})
    }

    this.$store.commit("ui/SET_LOADING", true);
    document.querySelector("html").style.overflow = "auto";
  },

  mounted() {
    console.log("route :", this.$route);


    this.setPaymentBottomNavbar(true);
    // TODO remove setTimeout
    setTimeout(() => {
      this.$store.commit("ui/SET_LOADING", false);
    }, 300);
  },
  data() {
    return {
      isBuyLoading: false
    };
  },
  created() {
    console.log('Payment.vue is created');
    // await this.setPaymentInfo();
  },
  computed: {
    ...mapGetters({
      showPaymentBottomNavbar: "ui/showPaymentBottomNavbar",
      userBasket: "user/userBasket",
      basketTotal: "user/basketTotal"
    }),
    stepIndicator() {
      // if user not signed in there will be 3 steps, if verified user 2
      if (!this.$store.state.user.userDoc) {
        console.log("no auth user object in store, returning the functionsl");
        return ;
      }
      const totalSteps = this.$store.state.user.userDoc.isEmailVerified ? 2 : 3;

      if (this.$route.name === "payment-event-rules") {
        return `1/${totalSteps}`;
      }
      if (this.$route.name === "payment-customer-info") {
        return `2/${totalSteps}`;
      }
      if (totalSteps === 2 && this.$route.name === "payment-card-info") {
        return `2/${totalSteps}`;
      } else if (totalSteps === 3 && this.$route.name === "payment-card-info") {
        return `3/${totalSteps}`;
      }
      return 'bull'
    }
  },
  methods: {
    ...mapMutations({
      setPaymentBottomNavbar: "ui/SET_PAYMENT_BOTTOM_NAVBAR"
    }),
    goPreviousRoute() {
      console.log('go previus');
      this.$store.commit("ui/SET_ROUTE_LOCK", false)
      this.$router.go(-1)
    },
    agreeEventRules() {
      this.$store.commit("user/SET_EVENT_RULES_ACCEPTED", true);
      this.$router.push({ name: "payment-customer-info" });
    },
    confirmCustomerInfo() {
      // at this point save user data to DB
      this.$router.push({ name: "payment-card-info" });
    },
    makePayment() {
      console.log("give me my money bitch");
    },
    // async setPaymentInfo() {
    //   const res = await this.$store.dispatch('user/setPaymentInfo')  
    // }
  
  },

  // beforeRouteLeave(to, from, next) {
  //   if (this.$store.state.ui.isRouteLocked) {
  //     // this.$store.commit("ui/SET_TICKET_MODAL", )
  //     next(false);
  //   } else {
  //     next();
  //   }
  // }
};
</script>


